let gallerySlideshowSwiper = new Swiper('.gallery-display-as-slideshow .swiper', {
	slidesPerView: 'auto',
	spaceBetween:  16,
	speed:         500,
	autoHeight:    true,
	pagination:    {
		el:        ".swiper-pagination",
		clickable: true
	},
	/*loop:          true,
	autoplay:      {
		delay:                3000,
		stopOnLastSlide:      false
	},*/
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	}
});


let slideshowSwiper = new Swiper('.slideshow .swiper', {
	slidesPerView: 'auto',
	spaceBetween: 24,
	slidesOffsetBefore: 24,
	slidesOffsetAfter: 24,
	navigation: {
		nextEl: '.slideshow-realizzazioni .swiper-button-next',
		prevEl: '.slideshow-realizzazioni .swiper-button-prev',
	},
	breakpoints:        {
		992: {
			slidesOffsetBefore: 48,
			slidesOffsetAfter: 48,
		}
	},
	/*pagination: {
		el: '.slideshow .swiper-pagination',
		type: 'custom',
		renderCustom: function (swiper, current, total) {
			return '<span class="swiper-pagination-current">' + current + '</span> <span class="swiper-pagination-separator"></span> <span class="swiper-pagination-total">' + total + '</span>';
		}
	}*/
});


const sliders = document.querySelectorAll('.page-template-template-configuratore .swiper');

sliders.forEach((slider) => {
	let swiperInstance = null;

	const checkAndToggleSwiper = () => {
		const wrapper = slider.querySelector('.swiper-wrapper');
		const slides  = wrapper.querySelectorAll('.swiper-slide:not(.disabled)');

		// Use getBoundingClientRect for accurate width (even for flex/auto widths)
		const totalSlidesWidth = Array.from(slides).reduce((total, slide) => {
			const style       = window.getComputedStyle(slide);
			const marginLeft  = parseFloat(style.marginLeft) || 0;
			const marginRight = parseFloat(style.marginRight) || 0;
			return total + slide.getBoundingClientRect().width + marginLeft + marginRight;
		}, 0);

		const viewportWidth = slider.clientWidth - 48;

		if (totalSlidesWidth > viewportWidth)
		{
			if (!swiperInstance)
			{
				swiperInstance = new Swiper(slider, {
					slidesPerView:      'auto',
					spaceBetween:       8,
					watchOverflow:      false,
					slidesOffsetBefore: 24,
					slidesOffsetAfter:  16,
					navigation:         {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev',
					},
					breakpoints:        {
						992: {
							spaceBetween:       24,
							slidesOffsetBefore: () => {
								return (window.visualViewport.width - 72) / 12 + 48;
							},
						}
					},
				});
			}
		}
		else
		{
			if (swiperInstance)
			{
				swiperInstance.destroy(true, true);
				swiperInstance = null;
			}
		}
	};

	// Watch size changes of container & slide contents
	const resizeObserver = new ResizeObserver(checkAndToggleSwiper);
	resizeObserver.observe(slider);

	// Also observe wrapper for any internal changes
	const wrapper = slider.querySelector('.swiper-wrapper');
	if (wrapper)
	{
		resizeObserver.observe(wrapper);
	}

	// Initial check after a short delay to ensure layout is ready
	setTimeout(checkAndToggleSwiper, 100);
});